export default "__VITE_ASSET__ksOZaxMu__"